import React, { Component } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FormControl } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import strings from './language/language';

const styles = (theme) => ({
  radioLabel: {
    width: '100%',
    //marginLeft: '10px',
    //marginTop: '-3px',
    //fontFamily: 'helveticaRoman'
  },
});
class RadioButton extends Component {
  state = {
    value: 'small',
    chocolate: true,
    cream: false,
    cherries: false,
  };
  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  render() {
    const { classes, promoCode } = this.props;
    const { chocolate, cream, cherries } = this.state;

    // promo code for order item price
    const promoCodePrice = (price) => {
      const promoCodeDiscountOrder = (price / 100) * promoCode;
      const promoCodeOrder = price - promoCodeDiscountOrder;
      return (
        promoCode && (
          <span
            className={classNames(classes.promoCodePrice, 'item-price')}
            style={{ marginLeft: 5, fontSize: 15 }}
          >
            {promoCodeOrder.toFixed(2)} {strings.currency}
          </span>
        )
      );
    };

    return (
      <React.Fragment>
        <div className='item-container'>
          <div className='sizes-row'>
            <FormControl className='form-control-group'>
              <RadioGroup onChange={this.props.click} value={this.props.value}>
                {Object.keys(this.props.items).map((item) => {
                  return (
                    //  <Grid container spacing={16}> <Grid item xs={6}>
                    <FormControlLabel
                      className='options'
                      value={item + '%' + this.props.items[item]}
                      control={
                        <Radio
                          labelStyle={{ color: '#1c9a52' }}
                          iconStyle={{
                            fill: this.props.color
                              ? this.props.color
                              : '#70142b',
                          }}
                          inputStyle={{
                            color: this.props.color
                              ? this.props.color
                              : '#70142b',
                          }}
                          style={{
                            color: this.props.color
                              ? this.props.color
                              : '#70142b',
                          }}
                        />
                      }
                      classes={{ label: classes.radioLabel }}
                      label={
                        <React.Fragment>
                          <Grid
                            container
                            justify='space-between'
                            alignItems='center'
                          >
                            <Grid item xs={7}>
                              <div
                                className='radiobutton-label'
                                variant='headline'
                              >
                                {item}
                              </div>
                            </Grid>
                            <Grid item xs={5}>
                              <span
                                style={{
                                  color: this.props.color
                                    ? this.props.color
                                    : '#70142b',
                                  textDecoration: promoCode
                                    ? 'line-through'
                                    : 'none',
                                  fontSize: 15,
                                  display: 'inline-block',
                                  marginTop: 7,
                                  fontFamily: 'Cabin',
                                }}
                              >
                                {this.props.items[item]}
                                {!promoCode && strings.currency}
                              </span>
                              {promoCodePrice(this.props.items[item])}
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      }
                    />
                  );
                })}
                {/* <MultiSelect prices={props.items}  /> */}
                {/* <FormControlLabel className="options" value="" checked="" control={<Radio labelStyle={{color: '#1c9a52'}}
                            iconStyle={{fill: '#1c9a52'}}
                            inputStyle={{color:'#1c9a52'}}
                            style={{color:'#1c9a52'}}/>} label = {props.option} /> */}
              </RadioGroup>
            </FormControl>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(RadioButton);



// WEBPACK FOOTER //
// ./src/components/RadioButton.js